var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { Result, Button } from 'antd';
import { TbSpeakerphone } from 'react-icons/tb';
import { errorStore } from '../utils/ErrorStore';
var ErrorFallback = function (_a) {
    var error = _a.error, eventId = _a.eventId, resetError = _a.resetError;
    useEffect(function () {
        // Ensure error is captured when ErrorFallback renders
        errorStore.addError(error, 'high');
    }, [error, eventId]);
    var handleReportFeedback = function () {
        Sentry.showReportDialog({
            eventId: eventId,
            title: 'It looks like we\'re having issues.',
            subtitle: 'Our team has been notified. Please share additional details:',
            user: {
                email: localStorage.getItem('loggedInEmail') || '',
                name: localStorage.getItem('loggedInName') || '',
            }
        });
    };
    return (_jsx("div", __assign({ className: "flex items-center justify-center min-h-screen bg-gray-50 p-4" }, { children: _jsx(Result, __assign({ status: "500", title: "Oops! Something went wrong", subTitle: "We've been notified and are working on a fix. You can try reloading the page.", extra: [
                _jsx(Button, __assign({ type: "primary", onClick: function () { return window.location.reload(); } }, { children: "Reload App" }), "reload"),
                _jsx(Button, __assign({ icon: _jsx(TbSpeakerphone, {}, void 0), onClick: handleReportFeedback }, { children: "Report Issue" }), "report"),
            ] }, { children: _jsxs("div", __assign({ className: "mt-4 text-left bg-gray-100 p-4 rounded" }, { children: [_jsx("p", __assign({ className: "font-semibold text-red-600" }, { children: "Error Details:" }), void 0), _jsx("p", __assign({ className: "text-sm mt-2 font-mono" }, { children: error.message }), void 0), _jsxs("p", __assign({ className: "text-xs text-gray-500 mt-2" }, { children: ["Event ID: ", eventId] }), void 0)] }), void 0) }), void 0) }), void 0));
};
export default ErrorFallback;
